import { NJModal, NJModalContent, NJButton, NJFormItem } from '@engie-group/fluid-design-system-react';
import { useState, useEffect } from 'react';
import './ModalSaveJobAd.css';

function ModalSaveJobAd({ isOpen, title, handleSave, handleCancel }) {

    const [name, setName] = useState('');

    useEffect(() => {
        setName(title);
    }, [title, isOpen]);

    return (
        <NJModal
            id="modalSave"
            isOpen={isOpen}
        >
            <NJModalContent
                footer={
                    <>
                        <NJButton
                            emphasis="subtle"
                            label="Cancel"
                            onClick={handleCancel}
                        />
                        <NJButton
                            label="Save the Ad"
                            disabled={!name}
                            onClick={() => { handleSave(name) }}
                            placeholder="Please enter a name"
                            icon='save'
                        />
                    </>
                }
                icon="save"
                id="modalSave"
                onClose={handleCancel}
                title="Save the template as"
            >
                <div className='modal-save-message'>
                    Save as:
                </div>
                <NJFormItem
                    className='dashboard-job-input-hide-label'
                    label="" // Hide the label
                    name="myInput"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    labelKind="static"
                />

            </NJModalContent>
        </NJModal>
    )
}

export default ModalSaveJobAd;
